import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import errorTranslator, {
  ErrorMessage as ErrorMessageType
} from "services/firebase/auth/errorTranslator";

import { removeUndefinedKeys } from "seneca-common/utils/functions";

import { signUp } from "features/user";

type Props = {
  email?: string;
  accountType?: string;
  onSubmitSuccess: (parentMarketingEnabled: boolean) => void;
};

type SignUpEmailForm = {
  email: string;
  password: string;
  termsAndConditions: boolean;
  isSubscribedToMarketingEmails?: boolean;
};

export default function useSignUpEmailForm({
  email,
  accountType,
  onSubmitSuccess
}: Props) {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState<
    ErrorMessageType | undefined
  >();

  const form = useForm<SignUpEmailForm>({
    defaultValues: { email },
    mode: "onSubmit"
  });

  const onSubmit: SubmitHandler<SignUpEmailForm> = async ({
    password,
    ...values
  }) => {
    const userDetails = removeUndefinedKeys({
      ...values,
      type: accountType
    });

    try {
      await dispatch(
        signUp({
          userDetails,
          password,
          isSubscribedToMarketingEmails: values.isSubscribedToMarketingEmails
        })
      );
      onSubmitSuccess(values.isSubscribedToMarketingEmails ?? false);
    } catch (error: any) {
      const errorMessage = errorTranslator(error);
      setErrorMessage(errorMessage);
    }
  };

  return { form, handleSubmit: form.handleSubmit(onSubmit), errorMessage };
}
